angular.module('app').component('supportHome', {
    bindings: {},
    templateUrl: 'scripts/app/partials/support/support-home.tpl.html',
    controllerAs: 'vm',
    controller: function (
    // angular
    $browser, $window, $scope, $timeout, $location, 
    // third party
    $localStorage, toastr, $uibModal, 
    // TODO: Add missing interfaces
    ModalService, UserDetails, DynamicMenuServiceApi, SettingsExService, NotifyService) {
        let vm = this;
        $window.vm = vm;
        vm.state = {
            userDetails: null
        };
        vm.data = {};
        vm.uploads = uploads;
        vm.navigate = navigate;
        vm.testNotify = testNotify;
        vm.setActive = setActive;
        this.$onInit = function () {
            init();
        };
        // TODO: Move this lot to TraceSummary and TraceDetails
        function testNotify() {
            NotifyService.show('This is a general WTP message', 'Web Testing Platform');
            NotifyService.newTraces('New traces have arrived for test AXP-001');
            NotifyService.newTraces('New traces have arrived for test AXP-002');
            NotifyService.newTraces('New traces have arrived for test AXP-003');
            NotifyService.newMessages('You have a WTP message from user xxx. Click here to read it.');
        }
        function setActive(isActive) {
            if (isActive) {
                NotifyService.switchOn();
            }
            else {
                NotifyService.switchOff();
            }
        }
        let init = function () {
            SettingsExService.getSettings().then(function (response) {
                let appSettings = response.data;
                vm.state.appSettings = appSettings;
                // console.info(appSettings);
            });
            UserDetails.get().then(function (data) {
                // Get our user details
                vm.state.userDetails = data; // setup our user details
            }, function () {
                toastr.error('Please make sure that you are logged in to OTS UTP!');
                $window.location.href =
                    $browser.baseHref() + 'account/login';
                return;
            });
            DynamicMenuServiceApi.navItems().then(function (response) {
                let menuItems = response.data;
                vm.menuItems = menuItems;
                /*
                    NOTE: The menuItems are trimmed on the server for the Admin and Support Roles
                    NOTE: The ManageSysAlert and Uploads menu items and link list items
                          are inserted manually at the end of the list generated from menuItems
                          Admin always gets the ManageSysAlert item
                          Support gets Uploads if web.config UploadModule flag is true
                    */
            });
        };
        function navigate(url) {
            $window.location.href = $browser.baseHref() + url;
        }
        // SVG stuff
        vm.Pass = 50;
        vm.Fail = 20;
        vm.Untested = 20;
        vm.NumTests = vm.Pass + vm.Fail + vm.Untested;
        vm.show = function (label) {
            console.log(label);
            vm.label = label;
        };
        function uploads() {
            $location.path('/Uploads/AspNetUsers/' + vm.state.userDetails.Id);
        }
    }
});
